// Leaflet base CSS (bundled separately so it only loads on single place pages).
import 'leaflet/dist/leaflet.css';

import { initPlaceStagesMap } from './modules/place-stages-map.js';

document.addEventListener( 'DOMContentLoaded', () => {
	initPlaceStagesMap();
} );
